import { render, staticRenderFns } from "./myToDo.vue?vue&type=template&id=14b0874e&scoped=true"
import script from "./myToDo.vue?vue&type=script&lang=js"
export * from "./myToDo.vue?vue&type=script&lang=js"
import style0 from "./myToDo.vue?vue&type=style&index=0&id=14b0874e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b0874e",
  null
  
)

export default component.exports